function initializeBrazeEvents() {
  if (typeof braze === 'undefined' || !braze.isInitialized()) {
    setTimeout(initializeBrazeEvents, 200);
    return;
  }

  // Use current origin to support both Learn and Shopify production domains
  const baseURL = window.location.origin + '/';
  const USER_STORAGE_KEY = 'brazeUserId';
  
  function extractFromUrl(prefix) {
    const urlWithoutParams = window.location.href.split('?')[0]; // Remove everything after '?'
    if (!urlWithoutParams.startsWith(prefix)) return '';
    const urlPart = urlWithoutParams.slice(prefix.length);
    return urlPart.split('/')[0];
  }

  function isPage(path) {
    return window.location.href.startsWith(`${baseURL}${path}`);
  }

  function logEvent(eventName, attributes = {}) {
    console.log(`Logging event: ${eventName}`, attributes);
    braze.logCustomEvent(eventName, attributes);
  }

  function removeUtmParams(url) {
    const urlObj = new URL(url);
    urlObj.searchParams.forEach((value, key) => {
      if (key.startsWith('utm_')) {
        urlObj.searchParams.delete(key);
      }
    });
    return urlObj.toString();
  }

  function checkAndLogPageView() {
    const cleanUrl = removeUtmParams(window.location.href);

    if (cleanUrl.includes(`${baseURL}products/`)) {
      const productName = extractFromUrl(`${baseURL}products/`);
      if (productName) {
        logEvent('viewed_product_page', { path: cleanUrl, product: productName });
        const user = braze.getUser();
        if (user && typeof user.addToCustomAttributeArray === 'function') {
          user.addToCustomAttributeArray('viewed_products_pages', productName);
        }
      }
    } else if (cleanUrl.includes(`${baseURL}collections/catalog/products/`)) {
      const collectionProductName = extractFromUrl(`${baseURL}collections/catalog/products/`);
      if (collectionProductName) {
        logEvent('viewed_product_page', { path: cleanUrl, collection: collectionProductName });
        const user = braze.getUser();
        if (user && typeof user.addToCustomAttributeArray === 'function') {
          user.addToCustomAttributeArray('viewed_products_pages', collectionProductName);
        }
      }
    } else if (cleanUrl.includes(`${baseURL}collections/`)) {
      const collectionName = extractFromUrl(`${baseURL}collections/`);
      if (collectionName) {
        logEvent('viewed_collection_page', { path: cleanUrl, collection: collectionName });
        const user = braze.getUser();
        if (user && typeof user.addToCustomAttributeArray === 'function') {
          user.addToCustomAttributeArray('viewed_collections_pages', collectionName);
        }
      }
    }

    if (isPage('collections/catalog')) {
      logEvent('viewed_catalog_page', { path: cleanUrl });
    }

    if (typeof braze.requestImmediateDataFlush === 'function') {
      braze.requestImmediateDataFlush();
    }
  }

  // Identify the user using ?user=external_id, fallback to stored value
  (function identifyUser() {
    const params = new URLSearchParams(window.location.search);
    const userFromUrl = params.get('user');
    const storedUser = localStorage.getItem(USER_STORAGE_KEY);
    try {
      if (userFromUrl && typeof braze.changeUser === 'function') {
        braze.changeUser(userFromUrl);
        localStorage.setItem(USER_STORAGE_KEY, userFromUrl);
        console.log('Braze user identified via URL param:', userFromUrl);
      } else if (!userFromUrl && storedUser && typeof braze.changeUser === 'function') {
        braze.changeUser(storedUser);
        console.log('Braze user identified via stored value:', storedUser);
      }
    } catch (e) {
      console.warn('Failed to change Braze user:', e);
    }
  })();

  // Clean URL and update browser history
  const cleanUrl = removeUtmParams(window.location.href);
  if (cleanUrl !== window.location.href) {
    window.history.replaceState({}, document.title, cleanUrl);
  }

  // Initial check
  checkAndLogPageView();

  // Listen for Shopify's navigation events
  document.addEventListener('page:load', checkAndLogPageView);
  document.addEventListener('turbolinks:load', checkAndLogPageView);

  // Fallback for other potential navigation methods
  window.addEventListener('popstate', checkAndLogPageView);
  window.addEventListener('hashchange', checkAndLogPageView);
}

// Initial setup
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeBrazeEvents);
} else {
  initializeBrazeEvents();
}